export default __webpack_public_path__ + "static/media/MobileIcon.18e71a33.svg";